import { Fragment, useEffect, useState } from "react"
import useFetch from "../../../hook/useFetch"
import Skeleton from "react-loading-skeleton"
import { productActions } from "../../../store/products-slice"
import { useDispatch, useSelector } from "react-redux"
import { notificationActions } from "../../../store/notification-slice"
import useFilter from "../../../hook/useFilter"
import { Link, useLocation, useParams } from "react-router-dom"
import ProductDetails from "./productdetails"
import useIsMobile from "../../../hook/useIsMobile"
import MobileComponent from './datatable/mobile';
import DesktopComponent from "./datatable/desktop"

export default function Products() {

    const { get } = useFetch()
    const [products, setProducts] = useState()
    let dispatch=useDispatch()
     const { convertToArray } = useFilter()

     const {id}=useParams()

     let location=useLocation()

     const fetchProducts=()=>{
         setProducts(null)
                dispatch(productActions.resetProducts())
        get(`/admin/products`, null, (data) => {
            dispatch(notificationActions.setNotification({
                message: data,
                status: false
            }))
        }, (data) => {
            data = convertToArray(data)
            setProducts(data)
            dispatch(productActions.setProducts(data))

        })
     }
    useEffect(() => {
       fetchProducts()
    }, [])

    useEffect(() => {
        if (location.state && location.state.refetch) {
            
            fetchProducts()
        }
    }, [location.state])

   const { isMobile } = useIsMobile()

    if (!products) {
        return <Skeleton count={50} />
    }

    if(id){
        return <ProductDetails id={id} />
    }


    return   <div className="rso-pages card shadow  bg-white rounded p-3 m-0">{isMobile ? <MobileComponent /> : <DesktopComponent />}</div>
}